import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { GamificationResult } from '../../../models/gamification';
import { Match } from '../../../models/match';
import { RecapCardService } from '../../services/recap-card.service';
import { BadgeTrack, BadgeTrackLabels, BadgeTrackIcons } from '../../../models/badge';

@Component({
	standalone: false,
	selector: 'gamification-celebration',
	templateUrl: 'gamification-celebration.component.html',
	styleUrls: ['gamification-celebration.component.scss']
})
export class GamificationCelebrationComponent {
	@Input() result: GamificationResult;
	@Input() match?: Match;

	constructor(private modalCtrl: ModalController, private recapCardService: RecapCardService) {

	}

	badgeLabel(track: BadgeTrack): string {
		return BadgeTrackLabels[track];
	}

	badgeIcon(track: BadgeTrack): string {
		return BadgeTrackIcons[track];
	}

	shareRecap(): void {
		this.recapCardService.share(this.match, this.result).catch(() => { /* share sheet dismissed */ });
	}

	close(): void {
		this.modalCtrl.dismiss();
	}
}
